import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Tasteful "Submit a Story" prompts. variant: "article" | "home" | "listing"
export const SubmitStoryCTA = ({ variant = "article", tone = "bg-white" }) => {
  if (variant === "home") {
    return (
      <section className={`py-12 md:py-16 ${tone}`} data-testid="submit-cta-home">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="max-w-2xl">
            <span className="text-[11px] font-bold tracking-[0.25em] uppercase text-[#7A1921] block mb-3">Know someone who matters?</span>
            <h2 className="font-serif text-2xl md:text-3xl font-bold tracking-tight text-neutral-950 mb-2">Have a story that matters?</h2>
            <p className="text-neutral-600 text-sm md:text-base">Pitch a person, company, brand or initiative to the People Who Matter editorial team.</p>
          </div>
          <Link to="/submit-story" className="inline-flex items-center gap-3 px-7 py-4 border border-neutral-950 text-neutral-950 text-[11px] font-bold tracking-[0.25em] uppercase hover:bg-neutral-950 hover:text-white transition-colors flex-shrink-0 self-start md:self-auto" data-testid="submit-cta-home-link">
            Submit a story <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    );
  }
  if (variant === "listing") {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16 md:pb-20" data-testid="submit-cta-listing">
        <div className="border-t border-neutral-200 pt-8 flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6">
          <p className="text-neutral-600 text-sm">Think we should know about someone or something?</p>
          <Link to="/submit-story" className="inline-flex items-center gap-1.5 text-sm font-semibold text-neutral-950 hover:text-[#7A1921] transition-colors" data-testid="submit-cta-listing-link">Submit it for editorial consideration <ArrowRight className="w-3.5 h-3.5" /></Link>
        </div>
      </div>
    );
  }
  return (
    <div className="mt-10 border-l-2 border-[#B89947] pl-5 py-1" data-testid="submit-cta-article">
      <span className="text-[10px] font-bold tracking-[0.25em] uppercase text-neutral-500 block mb-1.5">Know someone who matters?</span>
      <p className="text-neutral-700 text-sm mb-2">Have a person, achievement or story our editors should know about?</p>
      <Link to="/submit-story" className="inline-flex items-center gap-1.5 text-sm font-semibold text-neutral-950 hover:text-[#7A1921] transition-colors" data-testid="submit-cta-article-link">Submit a Story <ArrowRight className="w-3.5 h-3.5" /></Link>
    </div>
  );
};

export default SubmitStoryCTA;
